import React from 'react';
import { UpsellPanelSteps } from '../../../../../constants/upsellPanelEnumsAndConstants';
import { useUpsellWidgetContainer } from '../../../hooks/useUpsellWidgetContainerContext';
import { Constants } from '../../../../../constants';

export const Step5UpgradeUserContent = () => {
    const { baseProps, currentStep, headerFontClass } = useUpsellWidgetContainer();

    if (currentStep !== UpsellPanelSteps.Step5UpgradeUser) {
        return null;
    }

    return (
        <h2 className={`${headerFontClass} font-circular-std-bold `}>
            {baseProps.content.upgradeHeading ?? Constants.UPSELL_UPGRADE_HEADING}
        </h2>
    );
};
